<template>
  <b-modal
    v-model="show"
    :title="$t('PAYROLL TRACKING')"
    modal-class="modal-primary"
    hide-footer
    @hidden="$emit('hideModal')"
    size="lg"
    scrollable
  >
    <div class="mb-2 mt-1">
      <b-row>
        <b-col sm="12">
          <b-input-group class="mb-1">
            <template #prepend>
              <b-input-group-text class="prepend__width">
                <strong>{{ $t("Employee") }}</strong>
              </b-input-group-text>
            </template>
            <b-form-input :value="payroll.name" disabled />
          </b-input-group>
        </b-col>
      </b-row>
    </div>
    <div class="table-responsive">
      <b-table
        small
        sticky-header="50vh"
        class="position-relative"
        table-class="text-nowrap"
        :items="items"
        :fields="fields"
      >
        <template #cell(created_by)="data">
          <span> {{ data.value | capitalize }} </span> <br />
        </template>
        <template #cell(status)="data">
          <b-badge pill :variant="getPayrollStatusVariant(data.value)">
            <span> {{ $t(data.value) }}</span>
          </b-badge>
        </template>
        <template #cell(observation)="data">
          <span style="opacity: 0.5">
            <span> {{ $t(data.value) }}</span>
          </span>
        </template>
        <template #cell(created_at)="data">
          <span style="opacity: 0.5">
            {{ data.item.created_at | prettyDate }}
          </span>
        </template>
        <template #cell(updated_at)="data">
          <span style="opacity: 0.5">
            {{ data.item.updated_at | prettyDate }}
          </span>
        </template>
      </b-table>
    </div>
  </b-modal>
</template>

<script>
import AdministrativePayrollService from "@/views/rrhh/views/payroll/services/administrative-payroll.service.js";

export default {
  props: {
    payroll: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      items: [],
      show: true,
      fields: [
        { key: "created_by", label: this.$t("Created By") },
        { key: "status", label: this.$t("Status") },
        { key: "observation", label: this.$t("Observation") },
        { key: "created_at", label: this.$t("Created At") },
        { key: "updated_at", label: this.$t("Updated At") },
      ],
    };
  },
  async created() {
    await this.getAdministrativePayrollTracking();
  },
  methods: {
    async getAdministrativePayrollTracking() {
      try {
        this.addPreloader();
        const params = {
          payroll_id: this.payroll.id,
        };
        const { data } =
          await AdministrativePayrollService.getAdministrativePayrollTracking(
            params
          );
        this.items = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    getPayrollStatusVariant(status) {
      const variant = {
        "Fortnight Generated": "light-primary",
        "Fortnight Pending": "light-warning",
        "Fortnight Paid": "light-success",
        "Generated Salary": "light-primary",
        Approved: "light-success",
        Paid: "light-success",
        default: "light-info",
      };

      return variant[status] || variant.default;
    },
  },
};
</script>